/* eslint-disable no-console */
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LoggerService {
  private readonly isProduction = environment.production;
  private ctx: string[] = [];

  writeLog(logfn: (...args: unknown[]) => void, msg: any, ...optionalParams: any[]): void {
    if (this.isProduction) {
      return;
    }
    if (this.ctx.length === 0) {
      logfn.call(this, msg, ...optionalParams);
    } else {
      logfn.call(this, `[${this.ctx.join('.')}]`, msg, ...optionalParams);
    }
  }
  log(msg: any, ...optionalParams: any[]): void {
    this.writeLog(console.info, msg, ...optionalParams);
  }

  error(msg: any, ...optionalParams: any[]): void {
    this.writeLog(console.error, msg, ...optionalParams);
  }

  warn(msg: any, ...optionalParams: any[]): void {
    this.writeLog(console.warn, msg, ...optionalParams);
  }
  debug(msg: any, ...optionalParams: any[]): void {
    this.writeLog(console.debug, msg, ...optionalParams);
  }
  withContext(childCtx: string | { name: string }): LoggerService {
    if (typeof childCtx === 'object' || typeof childCtx === 'function') {
      return this.withContext(childCtx.name.replace(/^_/, ''));
    }
    const logger = new LoggerService();
    logger.ctx = [...this.ctx, childCtx];
    return logger;
  }
  constructor() {}
}
